import { useState, useEffect, lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./styles/App.css";
import { ThemeContext } from "./context/ThemeContext";
import { ThirdPartyContext } from "./context/ThirdPartyContext";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";

const MetaPage = lazy(() => import("./pages/MetaPage"));
const HistoryPage = lazy(() => import("./pages/HistoryPage"));
const HeroPage = lazy(() => import("./pages/HeroPage"));
const FaqPage = lazy(() => import("./pages/FaqPage"));
const TeamupsPage = lazy(() => import("./pages/TeamupsPage"));

const lightTheme = createTheme({ palette: { mode: "light" } });
const darkTheme = createTheme({ palette: { mode: "dark" } });

function App() {
    const [isDark, setIsDark] = useState(
        () => window.matchMedia("(prefers-color-scheme: dark)").matches,
    );
    const [includeThirdParty, setIncludeThirdParty] = useState(true);
    const [includeMirrorMatches, setIncludeMirrorMatches] = useState(true);

    useEffect(() => {
        document.body.classList.toggle("dark", isDark);
    }, [isDark]);

    return (
        <ThemeContext.Provider value={{ isDark, toggleDark: () => setIsDark((d) => !d) }}>
            <ThirdPartyContext.Provider value={{ includeThirdParty, toggleThirdParty: () => { setIncludeThirdParty((v) => { if (v) setIncludeMirrorMatches(true); return !v; }); }, includeMirrorMatches, toggleMirrorMatches: () => setIncludeMirrorMatches((v) => !v) }}>
                <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
                    <div className="App">
                        <NavBar />
                        <div className="page-content">
                            <Suspense>
                                <Routes>
                                    <Route path="/" element={<MetaPage />} />
                                    <Route path="/history" element={<HistoryPage />} />
                                    <Route path="/hero/*" element={<HeroPage />} />
                                    <Route path="/faq" element={<FaqPage />} />
                                    <Route path="/teamups" element={<TeamupsPage />} />
                                </Routes>
                            </Suspense>
                        </div>
                        <Footer />
                    </div>
                </ThemeProvider>
            </ThirdPartyContext.Provider>
        </ThemeContext.Provider>
    );
}

export default App;
